<template>
  <div class="table-header">
    <div class="table-header__start" v-if="title">
      <h2 class="table-header__title">
        {{ title }}
      </h2>
      <slot></slot>
    </div>

    <div class="table-header__end" v-if="collection && collection.pagination && !collection.refreshing">
      <span>
        {{ collection.pagination.currentPageStart }}-{{ collection.pagination.currentPageEnd }} of
        {{ collection.pagination.totalCount }}
      </span>
      <md-button
        class="md-icon-button"
        @click="() => collection.prevPage()"
        :disabled="!collection || !collection.pagination || !collection.pagination.hasPrevPage"
      >
        <md-icon>chevron_left</md-icon>
      </md-button>
      <md-button
        class="md-icon-button"
        @click="() => collection.nextPage()"
        :disabled="!collection || !collection.pagination || !collection.pagination.hasNextPage"
      >
        <md-icon>chevron_right</md-icon>
      </md-button>
    </div>
  </div>
</template>

<script>
/**
 * Table Header
 *
 * Renders the header of a table with pagination controls
 *
 * @prop {String} title - The title to show in the table header
 * @prop {CollectionManager} collection - The collection presented by the table
 *
 * DEPENDS ON THE VUE MATERIAL LIBRARY
 */
export default {
  name: 'TableHeader',
  props: {
    title: {
      type: String,
      default: '',
    },
    collection: {
      type: [Object,Array],
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.table-header {
  display: flex;

  &__start {
    display: flex;
    padding: 1rem 0 1rem 0;
  }

  &__title {
    margin: 0;
    align-self: center;
  }

  &__end {
    flex: 4;
    align-self: flex-end;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-bottom: 1rem;
  }
}
</style>
